<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết cộng tác viên</h1>
      <div class="" style="float: right">
        <button
          v-if="edit === false && dataPermission.includes('CNPS_AGENT_UPLOAD_FILE')"
          @click="edit = true"
          class="btn btn-primary ml-2"
          data-toggle="modal"
        >
          Sửa
        </button>
        <button v-if="edit === true" @click="edit = false" class="btn btn-secondary ml-2">
          Hủy bỏ
        </button>
        <button v-if="edit === true" @click="saveFile()" class="btn btn-primary ml-2">Lưu</button>
        <button
          v-if="identity.status === 'PENDING' && identity.status && edit === false"
          @click="rejectCollaborator"
          class="btn btn-danger ml-2"
          data-toggle="modal"
        >
          Từ chối
        </button>
        <button
          v-if="identity.status === 'PENDING' && identity.status && edit === false"
          @click="confirmAgent"
          class="btn btn-primary ml-2"
        >
          Duyệt
        </button>
        <button @click="backtoList" class="btn btn-outline-secondary ml-2">Quay lại</button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>Thông tin chung</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Họ tên<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ info.name }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Email<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ info.email }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số điện thoại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ info.mobile }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ info.address }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span class="badge badge-primary" v-if="info.stateAgent === 'ACTIVE'"
                    >Đang hoạt động</span
                  >
                  <span class="badge badge-danger" v-if="info.stateAgent === 'LOCKED'"
                    >Đã khóa</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail" v-if="identity.status !== 'NOT_YET' && identity.status">
            <h1>Thông tin CMND/CCCD/HC</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số CMND/CCCD/HC<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ identity.idNumber }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Cấp ngày<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ identity.issueDate | formatDate }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Nơi cấp<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ identity.issueBy }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Địa chỉ thường trú<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ identity.permanentAddress }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Sinh ngày<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ identity.dateOfBirth | formatDate }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail" v-if="bankAccount">
            <h1>Tài khoản ngân hàng</h1>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Chủ tài khoản</th>
                    <th>Tên ngân hàng</th>
                    <th>Số tài khoản</th>
                    <th>Chi nhánh</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row" v-for="(item, index) in bankAccount" :key="index">
                    <td>{{ item.accountName }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.accountNumber }}</td>
                    <td>{{ item.branch }}</td>
                    <td align="center">
                      <i
                        v-if="item.isActive == true"
                        class="bx bx-check-circle"
                        style="font-size: 23px; color: #007bff"
                      ></i>
                      <i
                        v-else
                        class="bx bx-minus-circle"
                        style="font-size: 23px; color: #8a8a8a"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="form-detail" v-if="contractAgent">
            <h1>Hợp đồng</h1>
            <div class="table-responsive">
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <!-- <td><router-link :to="`/preview-contract-ctv?agentId=${agentId}`" v-if='contractAgent.codeContract'>{{ contractAgent.codeContract }}</router-link></td> -->
                    <td>
                      <a
                        href="#"
                        v-if="contractAgent.codeContract"
                        @click.prevent="openContractAgent(dataInfo)"
                      >
                        {{ contractAgent.codeContract }}
                      </a>
                    </td>
                    <td>
                      <span
                        class="badge badge-primary"
                        v-if="contractAgent.statusContract === 'REGISTER'"
                        >Đã ký</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="contractAgent.statusContract === 'UNREGISTER'"
                        >Chưa ký</span
                      >
                    </td>
                    <!-- <td width="120">
                        <button
                          class="f12 btn btn-outline-secondary"
                          @click="genPDF"
                        >
                          Tải file HĐ
                        </button>
                      </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="form-detail">
            <h1>Lịch sử xác thực</h1>
            <div class="tab-content" id="nav-tabContent">
              <div class="table-responsive">
                <table class="table table-hover table-bordered" id="tableScroll">
                  <thead>
                    <tr>
                      <th class="text-center">Loại xác thực</th>
                      <th class="text-center">Thời gian</th>
                      <th class="text-center">Người xác thực</th>
                      <th class="text-center">Trạng thái</th>
                      <th class="text-center">Lý do</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in dataHistoryConfirm" :key="index">
                      <td>
                        <div v-if="item.identity.typeCard === 'CMNDCCCD'">CMND/CCCD</div>
                        <div v-else>Hộ chiếu</div>
                      </td>
                      <td>
                        {{ item.createdDate | formatDate('HH:mm DD/MM/YYYY') }}
                      </td>
                      <td>
                        {{ item.approverUserName }}
                      </td>
                      <td>
                        <span
                          class="badge badge-primary"
                          style="margin-top: 22px"
                          v-if="item.identity.status === 'ACTIVE' && item.identity.status"
                          >Đã xác thực</span
                        ><br />
                        <span
                          class="badge badge-danger text-center"
                          style="margin-bottom: 22px"
                          v-if="item.identity.status === 'REFUSE' && item.identity.status"
                          >Đã từ chối</span
                        ><br />
                      </td>
                      <td>
                        {{ item.reason }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="img-list-wrapper">
            <h1 class="form-inner-heading">
              Ảnh đính kèm /
              <span
                class="badge badge-primary"
                v-if="identity.status === 'ACTIVE' && identity.status"
                >Đã xác thực</span
              >
              <span
                class="badge badge-danger"
                v-if="identity.status === 'REFUSE' && identity.status"
                >Đã từ chối</span
              >
              <span
                class="badge badge-warning"
                v-if="identity.status === 'PENDING' && identity.status"
                >Chờ xác thực</span
              >
              <span
                class="badge badge-success"
                v-if="identity.status === 'NOT_YET' && identity.status"
                >Chưa có ảnh</span
              >
            </h1>
            <div class="form-group row img-list mr-0 ml-0" v-if="identity.status !== 'NOT_YET'">
              <ul v-viewer>
                <li>
                  <a href="#" data-toggle="modal" id="attach-img">
                    <img :src="identity.front" alt="" />
                  </a>
                </li>
                <li>
                  <a href="#" data-toggle="modal" id="attach-img">
                    <img :src="identity.backside" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="img-list-wrapper">
            <UploadMultiple
              @syncFile="syncFile"
              :lsData="fileUploads"
              :maxFile="20"
              fileType="file"
              accept="*/*"
              title="File do admin bổ sung"
              titleTag="h1"
              titleClass="form-inner-heading"
              uniqueKey="images"
              :canUpload="edit"
            />
          </div>
        </div>
      </div>
    </div>
    <!--Từ chối duyệt-->
    <b-modal id="modal-scoped" v-model="rejectModal">
      <template #modal-header="{ close }">
        <h5>Lý do từ chối</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>

      <textarea v-model="textReason" class="form-control" :maxlength="225" rows="3"></textarea>

      <template #modal-footer="{}">
        <b-button size="sm" variant="light" @click="refuseAgent"> Xác nhận </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { AgentService } from '@/services/agent.service'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { CommonService } from '@/services/common.service'
  import { v4 as uuidv4 } from 'uuid'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        rejectModal: false,
        loading: true,
        agentId: this.$route.params.agentId,
        token: localStorage.getItem('token'),
        username: JSON.parse(localStorage.getItem('userData')).username,
        info: {},
        bankAccount: [],
        contractAgent: {},
        identity: {},
        dataHistoryConfirm: [],
        textReason: '',
        options: {
          defaultWidth: '100%',
          defaultHeight: '100%',
        },
        style: {
          width: '100%',
        },
        edit: false,
        fileUploads: [],
      }
    },
    mounted() {
      this.fetchData()
      this.historyConfirmAgent()
    },
    components: {
      UploadMultiple,
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      // Quay lại
      backtoList() {
        this.$router.push('/list-collaborators')
      },
      // Từ chối
      rejectCollaborator() {
        this.rejectModal = true
      },
      // lịch sử xác thực
      async historyConfirmAgent() {
        this.loading = true
        try {
          const data = await AgentService.historyConfirmAgent({
            agentId: this.agentId,
          })
          if (data.success) {
            this.dataHistoryConfirm = data.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // Confirm từ chối
      async refuseAgent() {
        this.rejectModal = false
        try {
          const data = await AgentService.acceptOrRefuseAgent({
            agentId: this.agentId,
            approverUsername: this.username,
            reason: this.textReason,
            status: 'REFUSE',
          })
          if (data.success) {
            this.historyConfirmAgent()
            this.fetchData()
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // duyệt
      async confirmAgent() {
        try {
          const data = await AgentService.acceptOrRefuseAgent({
            agentId: this.agentId,
            approverUsername: this.username,
            reason: '',
            status: 'ACTIVE',
          })
          if (data.success) {
            this.historyConfirmAgent()
            this.fetchData()
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // Dữ liệu chung
      async fetchData() {
        this.loading = true
        try {
          const data = await AgentService.getOneAgent({
            agentId: this.agentId,
          })
          if (data.success) {
            this.dataInfo = data.data
            this.info = {
              name: data.data.name,
              email: data.data.email,
              mobile: data.data.mobile,
              address: data.data.address,
              stateAgent: data.data.stateAgent,
            }
            const mappingData = (arr, type) =>
              arr.forEach(url => {
                const ar = { name: url, url, type, id: uuidv4() }
                this.fileUploads.push(ar)
              })
            this.identity = data.data.identity
            this.bankAccount = data.data.bankInfo
            this.contractAgent = data.data.contractAgent
            mappingData(data.data.fileUpload, 'images')
          }
        } catch (error) {}
      },

      openContractAgent(dataAgent) {
        window.open(`/preview-contract-ctv?agentId=${dataAgent.agentId}`, '_blank')
      },
      syncFile(files) {
        this.fileUploads = files
      },
      async saveFile() {
        this.loading = true
        try {
          const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
          const body = {
            agentId: this.agentId,
            fileUpload: files.map(s => s.urlFile),
          }
          const res = await AgentService.uploadDetailImage(body)
          if (res.success) {
            this.edit = false
            this.showSuccessMx('Bổ sung thành công')
          } else this.showFailMx(res.message)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadFile(formData)
          if (data.success === false) {
            this.showFailMx(data.message)
            throw new Error(data.message)
          }
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
    },
  }
</script>

<style scoped>
  .modal-dialog {
    float: right;
    margin-right: 7vw !important;
    overflow: auto;
    margin: 0 auto;
  }
  .modal-content {
    float: right !important;
    width: 100% !important;
  }
  .modal-mask {
    background-color: rgba(0, 0, 0, 0.2) !important;
  }
</style>
